@if (confirmationData) {
  <div class="row margin-top-30">
    <ds-confirmation [confirmationData]="confirmationData">
      <div [innerHTML]="confrimationSubheader"></div>
      <ds-confirmation-link-area>
        <div class="flex items-center link-button">
          <span class="back-icon icon-chevron-left"> </span>
          <a
            class="font-weight-semibold"
            href="javascript:void(0);"
            [contentPath]="'billing.backToBilling'"
            (click)="backtoOverview()"
            >Back To Overview
          </a>
        </div>
      </ds-confirmation-link-area>
    </ds-confirmation>
  </div>
}
